import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
  width={props.width || "18"}
  height={props.height || "18"}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_469_674)">
      <path
        d="M17.5427 16.7085L2.30089 1.46667C2.15716 1.32785 1.96465 1.25104 1.76483 1.25278C1.56501 1.25451 1.37387 1.33466 1.23258 1.47596C1.09128 1.61726 1.01113 1.8084 1.00939 2.00821C1.00766 2.20803 1.08447 2.40054 1.22329 2.54427L2.39158 3.71255C1.97891 3.88804 1.62696 4.18101 1.37953 4.555C1.1321 4.92899 1.00011 5.36749 1 5.81592V11.9126C1 12.519 1.24087 13.1005 1.66963 13.5293C2.09839 13.958 2.67991 14.1989 3.28627 14.1989H6.90238L12.8604 17.4492C13.3114 17.696 13.8325 17.7832 14.3392 17.6966C14.8459 17.61 15.3085 17.3547 15.6519 16.9722L16.4658 17.7861C16.6096 17.9249 16.8021 18.0017 17.0019 18C17.2017 17.9982 17.3929 17.9181 17.5342 17.7768C17.6755 17.6355 17.7556 17.4443 17.7573 17.2445C17.7591 17.0447 17.6815 16.8522 17.5427 16.7085Z"
        fill="#556987"
      />
      <path
        d="M16.2417 2.28669C16.2418 1.89 16.1387 1.50011 15.9424 1.15535C15.7462 0.810591 15.4636 0.522819 15.1225 0.320319C14.7814 0.117818 14.3935 0.00755825 13.9969 0.000374947C13.6002 -0.00680836 13.2086 0.0893324 12.8603 0.279348L6.90155 3.52966H6.52051L16.2417 13.2516V2.28669Z"
        fill="#556987"
      />
    </g>
    <defs>
      <clipPath id="clip0_469_674">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
